var map = {
	"./algeria.json": "b185",
	"./bolivia.json": "6ea6",
	"./bulgaria.json": "4553",
	"./chile.json": "cffa",
	"./china.json": "8e25",
	"./colombia.json": "ff50",
	"./egypt-native.json": "4611",
	"./egypt.json": "f4f8",
	"./en.json": "edd4",
	"./france.json": "0ba5",
	"./hungary.json": "9a7f",
	"./india.json": "8638",
	"./indonesia.json": "41d0",
	"./japan.json": "ba1a",
	"./mexico.json": "f53f",
	"./morocco-native.json": "e73f",
	"./morocco.json": "4a7c",
	"./peru.json": "9d83",
	"./philippines.json": "05b7",
	"./poland.json": "e848",
	"./portugal.json": "6bca",
	"./romania.json": "de17",
	"./saudi-arabia-native.json": "0b07",
	"./saudi-arabia.json": "37b4",
	"./singapore.json": "2085",
	"./spain.json": "fc52",
	"./thailand.json": "a12b",
	"./tunesia.json": "1de7",
	"./united-arab-emirates-native.json": "35a5",
	"./united-arab-emirates.json": "8871",
	"./vietnam.json": "95c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";